exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___1e43c{margin-top:10em}.index-module__wrapper___1e43c .index-module__title___H-YvN{text-transform:uppercase;color:#fff;letter-spacing:.5px;font-size:18px;font-weight:700;margin-bottom:.75em}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___1e43c",
	"title": "index-module__title___H-YvN"
};